if (!customElements.get('variant-selects')) {

  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.isDisabledFeature = this.dataset.isDisabled;
      this.addEventListener('change', this.onVariantChange);
      this.other = Array.from(document.querySelectorAll('variant-selects')).filter((selector) => {
        return selector != this;
      });
      this.productWrapper = this.closest('.thb-product-detail');
      if (this.productWrapper) {
        // 根据设备类型选择正确的MediaGallery
        this.productSlider = this.getCorrectProductSlider();
        this.thumbnails = this.getCorrectThumbnailContainer();
        this.hideVariants = this.productSlider && this.productSlider.dataset.hideVariants === 'true';
      }
      // 初始化已选样品数组
      this.selectedSwatches = [];
      this.maxSwatches = 1000;
    }

    getCorrectProductSlider() {
      // 检查是否为移动设备
      const isMobile = window.innerWidth <= 1067;

      if (isMobile) {
        // 移动端：优先查找移动端的MediaGallery
        const mobileGallery = this.productWrapper.querySelector('.media-gallery--mobile .product-images');
        if (mobileGallery && this.isElementVisible(mobileGallery)) {
          return mobileGallery;
        }
      } else {
        // 桌面端：优先查找桌面端的MediaGallery
        const desktopGallery = this.productWrapper.querySelector('.media-gallery--desktop .product-images');
        if (desktopGallery && this.isElementVisible(desktopGallery)) {
          return desktopGallery;
        }
      }

      // 回退：查找任何可见的.product-images
      const allGalleries = this.productWrapper.querySelectorAll('.product-images');
      for (let gallery of allGalleries) {
        if (this.isElementVisible(gallery)) {
          return gallery;
        }
      }

      // 最后回退：查找.product-quick-images
      return this.productWrapper.querySelector('.product-quick-images');
    }

    getCorrectThumbnailContainer() {
      if (!this.productSlider) return null;

      // 查找与当前productSlider相关联的缩略图容器
      const mediaGallery = this.productSlider.closest('.media-gallery');
      if (mediaGallery) {
        return mediaGallery.querySelector('.product-thumbnail-container');
      }

      // 回退：查找任何缩略图容器
      return this.productWrapper.querySelector('.product-thumbnail-container');
    }

    isElementVisible(element) {
      if (!element) return false;
      const style = window.getComputedStyle(element);
      return style.display !== 'none' && style.visibility !== 'hidden' && element.offsetParent !== null;
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
      this.setImageSet();
      this.updateFreeSwatchesButton();
      // 页面加载时从购物车恢复免费样品数据
      this.loadSelectedSwatchesFromCart();

      // 监听窗口大小变化，重新初始化MediaGallery选择
      this.handleResize = this.debounce(() => {
        const newProductSlider = this.getCorrectProductSlider();
        const newThumbnails = this.getCorrectThumbnailContainer();

        if (newProductSlider !== this.productSlider) {
          this.productSlider = newProductSlider;
          this.thumbnails = newThumbnails;
          this.hideVariants = this.productSlider && this.productSlider.dataset.hideVariants === 'true';
        }
      }, 250);

      window.addEventListener('resize', this.handleResize);
    }

    disconnectedCallback() {
      if (this.handleResize) {
        window.removeEventListener('resize', this.handleResize);
      }
    }

    debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }

    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      this.setDisabled();

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        if (this.updateUrl) {
          this.updateURL();
        }
        this.updateVariantInput();
        this.renderProductInfo();
        //this.updateShareUrl();
      }
      this.updateOther();
      this.updateFreeSwatchesButton();
      dispatchCustomEvent('product:variant-change', {
        variant: this.currentVariant,
        sectionId: this.dataset.section
      });
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = [];
      this.option_keys = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector('select')) {
          this.options.push(fieldset.querySelector('select').value);
          this.option_keys.push(fieldset.querySelector('select').name);
        } else if (fieldset.querySelectorAll('input').length) {
          this.options.push(fieldset.querySelector('input:checked').value);
          this.option_keys.push(fieldset.querySelector('input').name);
        }
      });
      this.dataset.options = this.options;
    }
    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector('.form__label__value');
        if (label) {
          label.innerHTML = this.options[i];
        }
      });
      
      // 打印当前选中的变体信息
      if (this.currentVariant) {
        console.log('🔄 变体切换:', {
          variantId: this.currentVariant.id,
          variantTitle: this.currentVariant.title,
          options: this.options,
          price: this.currentVariant.price
        });
      }
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        // 检查 variant 和 variant.options 是否存在
        if (!variant || !variant.options || !Array.isArray(variant.options)) {
          console.warn('⚠️ 变体数据不完整:', variant);
          return false;
        }
        
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
      
      // 添加调试信息
      if (this.currentVariant) {
        console.log('🎯 找到匹配的变体:', {
          id: this.currentVariant.id,
          title: this.currentVariant.title,
          options: this.currentVariant.options,
          price: this.currentVariant.price,
          available: this.currentVariant.available
        });
      } else {
        console.warn('⚠️ 未找到匹配的变体，当前选项:', this.options);
        console.log('📋 所有可用变体数据:', this.getVariantData());
      }
    }

    updateOther() {
      if (this.dataset.updateUrl === 'false') {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll('fieldset'),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (fieldsets_array[i].querySelector('select')) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll('input').length) {
            fieldsets_array[i].querySelector(`input[value="${option}"]`).checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].setDisabled();
      }
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;

      // 如果没有productSlider或者当前的不可见，重新查找
      if (!this.productSlider || !this.isElementVisible(this.productSlider)) {
        this.productSlider = this.getCorrectProductSlider();
        this.thumbnails = this.getCorrectThumbnailContainer();
        this.hideVariants = this.productSlider && this.productSlider.dataset.hideVariants === 'true';
      }

      if (!this.productSlider) return;
      let mediaId = `#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`;
      let activeMedia = this.productSlider.querySelector(mediaId);

      if (this.thumbnails) {
        this.setActiveMediaSlider(mediaId, `#Thumb-${this.dataset.section}-${this.currentVariant.featured_media.id}`, this.productSlider);
      } else {
        this.setActiveMedia(activeMedia);
      }

    }
    setActiveMedia(activeMedia) {
      if (!activeMedia) return;

      this.productSlider.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });

      this.setImageSetMedia();

      activeMedia.classList.add('is-active');

      activeMedia.parentElement.prepend(activeMedia);

      if (!this.sticky) {
        window.setTimeout(() => {
          if (window.innerWidth > 1068) {
            let header_h = activeMedia.parentElement.offsetTop - parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')),
              scroll_obj = {
                left: 0,
                behavior: 'instant'
              };

            if (header_h > 0) {
              scroll_obj.top = header_h;
            }
            window.scrollTo(scroll_obj);
          }
          activeMedia.parentElement.scrollTo({
            left: 0,
            behavior: 'instant'
          });
        });
      }
    }
    setActiveMediaSlider(mediaId, thumbId, productSlider) {
      let flkty = Flickity.data(productSlider),
        activeMedia = productSlider.querySelector(mediaId);

      if (flkty && this.hideVariants) {
        if (productSlider.querySelector('.product-images__slide.is-initial-selected')) {
          productSlider.querySelector('.product-images__slide.is-initial-selected').classList.remove('is-initial-selected');
        }
        [].forEach.call(productSlider.querySelectorAll('.product-images__slide-item--variant'), function (el) {
          el.classList.remove('is-active');
        });
        if (this.thumbnails) {
          if (this.thumbnails.querySelector('.product-thumbnail.is-initial-selected')) {
            this.thumbnails.querySelector('.product-thumbnail.is-initial-selected').classList.remove('is-initial-selected');
          }
          [].forEach.call(this.thumbnails.querySelectorAll('.product-images__slide-item--variant'), function (el) {
            el.classList.remove('is-active');
          });
        }

        activeMedia.classList.add('is-active');
        activeMedia.classList.add('is-initial-selected');

        this.setImageSetMedia();

        if (this.thumbnails) {
          let activeThumb = this.thumbnails.querySelector(thumbId);

          activeThumb.classList.add('is-active');
          activeThumb.classList.add('is-initial-selected');
        }

        productSlider.reInit(this.imageSetIndex);
        productSlider.selectCell(mediaId);

      } else if (flkty) {
        productSlider.selectCell(mediaId);
      }

    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');

      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [`price-${this.dataset.section}`, `price-${this.dataset.section}--sticky`, `product-image-${this.dataset.section}--sticky`, `inventory-${this.dataset.section}`, `sku-${this.dataset.section}`, `quantity-${this.dataset.section}`];
    }


    renderProductInfo() {
      let sections = this.getSectionsToRender();

      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);

            if (source && destination) destination.innerHTML = source.innerHTML;

            const price = document.getElementById(id);
            const price_fixed = document.getElementById(id + '--sticky');

            if (price) price.classList.remove('visibility-hidden');
            if (price_fixed) price_fixed.classList.remove('visibility-hidden');

          });
          this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);

        });
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;

      const productTemplate = productForm.closest('.product-form').getAttribute('template');
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      if (!submitButtons) return;

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');

        if (!submitButtonText) return;

        if (disable) {
          submitButton.setAttribute('disabled', 'disabled');
          if (text) submitButtonText.textContent = text;
        } else {
          submitButton.removeAttribute('disabled');
          submitButton.classList.remove('loading');

          if (productTemplate?.includes('pre-order')) {
            submitButtonText.textContent = window.theme.variantStrings.preOrder;
          } else {
            submitButtonText.textContent = window.theme.variantStrings.addToCart;
          }
        }
      });

      if (!modifyClass) return;
    }

    setUnavailable() {
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        if (!submitButton) return;
        submitButtonText.textContent = window.theme.variantStrings.unavailable;
        submitButton.classList.add('sold-out');
      });
      if (price) price.classList.add('visibility-hidden');
      if (price_fixed) price_fixed.classList.add('visibility-hidden');
    }

    setDisabled() {
      if (this.isDisabledFeature != 'true') {
        return;
      }
      const variant_data = this.getVariantData();


      if (variant_data) {
        let selected_options = false;
        if (this.currentVariant) {
          selected_options = this.currentVariant.options.map((value, index) => {
            return {
              value,
              index: `option${index + 1}`
            };
          });
        } else {
          let found_option = variant_data.find(option => {
            return option.option1 === this.options[0];
          });
          if (found_option) {
            selected_options = [
              {
                "value": this.options[0],
                "index": "option1"
              },
              {
                "value": found_option.option2,
                "index": "option2"
              }
            ];
          } else {
            return;
          }
        }

        const available_options = this.createAvailableOptionsTree(variant_data, selected_options);

        this.fieldsets.forEach((fieldset, i) => {
          const fieldset_options = Object.values(available_options)[i];

          if (fieldset_options) {
            if (fieldset.querySelector('select')) {
              fieldset_options.forEach((option, option_i) => {
                // 添加安全检查
                if (option && typeof option === 'object' && 'isUnavailable' in option) {
                  const optionElement = fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']');
                  if (optionElement) {
                    if (option.isUnavailable) {
                      optionElement.disabled = true;
                    } else {
                      optionElement.disabled = false;
                    }
                  }
                }
              });
            } else if (fieldset.querySelectorAll('input').length) {
              fieldset.querySelectorAll('input').forEach((input, input_i) => {
                // 添加边界检查，防止索引超出范围
                if (fieldset_options[input_i]) {
                  input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
                } else {
                  // 如果没有对应的选项数据，默认启用该输入
                  input.classList.remove('is-disabled');
                }
              });
            }
          }
        });

      }
      return true;
    }

    getImageSetName(variant_name) {
      return variant_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    }

    setImageSet() {
      if (!this.productSlider) return;

      let dataSetEl = this.productSlider.querySelector('[data-set-name]');
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        this.imageSetIndex = this.querySelector('.product-form__input[data-handle="' + this.imageSetName + '"]').dataset.index;
        this.dataset.imageSetIndex = this.imageSetIndex;
        this.setImageSetMedia();
      }
    }

    setImageSetMedia() {
      if (!this.imageSetIndex) {
        return;
      }
      let setValue = this.getImageSetName(this.currentVariant[this.imageSetIndex]);
      let group = this.imageSetName + '_' + setValue;
      let selected_set_images = this.productSlider.querySelectorAll(`.product-images__slide[data-set-name="${this.imageSetName}"]`),
        selected_set_thumbs = this.productWrapper.querySelectorAll(`.product-thumbnail[data-set-name="${this.imageSetName}"]`);

      if (this.hideVariants) {
        if (this.thumbnails) {
          // Product images
          this.productWrapper.querySelectorAll('.product-images__slide').forEach(thumb => {
            if (thumb.dataset.group && thumb.dataset.group !== group) {
              thumb.classList.remove('is-active');
            }
          });
          selected_set_images.forEach(thumb => {
            thumb.classList.toggle('is-active', thumb.dataset.group === group);
          });

          // Product thumbnails
          this.productWrapper.querySelectorAll('.product-thumbnail').forEach(thumb => {
            if (thumb.dataset.group && thumb.dataset.group !== group) {
              thumb.classList.remove('is-active');
            }
          });
          selected_set_thumbs.forEach(thumb => {
            thumb.classList.toggle('is-active', thumb.dataset.group === group);
          });
        } else {
          // Product images
          this.productWrapper.querySelectorAll('.product-images__slide').forEach(thumb => {
            if (thumb.dataset.group && thumb.dataset.group !== group) {
              thumb.classList.remove('is-active');
            }
          });
          selected_set_images.forEach(thumb => {
            if (thumb.dataset.group === group) {
              thumb.classList.add('is-active');
            }
          });
        }

      } else {

        if (!this.thumbnails) {
          let set_images = Array.from(selected_set_images).filter(function (element) {
            return element.dataset.group === group;
          });
          set_images.forEach(thumb => {
            thumb.parentElement.prepend(thumb);
          });
        }

      }
      if (!this.thumbnails) {
        setTimeout(() => {
          this.productSlider.querySelector('product-slider').onPaginationResize();
        }, 100);
      }
    }

    createAvailableOptionsTree(variants, currentlySelectedValues) {
      // Filter out free variants (price = 0) from variant selection
      const paidVariants = variants.filter(variant => {
        const variantPrice = variant.price || 0;
        return variantPrice > 0;
      });
      
      console.log(`🔍 变体过滤: 总变体 ${variants.length} 个, 付费变体 ${paidVariants.length} 个`);
      
      // Reduce variant array into option availability tree
      return paidVariants.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = { value: variant[index], isUnavailable: true };
            options[index].push(entry);
          }

          const currentOption1 = currentlySelectedValues.find(({ value, index }) => index === 'option1');
          const currentOption2 = currentlySelectedValues.find(({ value, index }) => index === 'option2');

          switch (index) {
            case 'option1':
              // Option1 inputs should always remain enabled based on all available variants
              entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
              break;
            case 'option2':
              // Option2 inputs should remain enabled based on available variants that match first option group
              if (currentOption1 && variant.option1 === currentOption1.value) {
                entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
              }
              break;
            case 'option3':
              // Option 3 inputs should remain enabled based on available variants that match first and second option group
              if (currentOption1 && variant.option1 === currentOption1.value && currentOption2 && variant.option2 === currentOption2.value) {
                entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
              }
          }
        });

        return options;
      }, { option1: [], option2: [], option3: [] });
    }

    getVariantData(includeFreeVariants = false) {
      // 如果需要包含免费变体（如免费样品功能），返回完整数据
      if (includeFreeVariants && this.allVariantData && this.allVariantData.length > 0) {
        return this.allVariantData;
      }
      
      // 默认返回过滤后的付费变体数据（用于变体选择器）
      if (this.variantData && this.variantData.length > 0) {
        return this.variantData;
      }
      
      // 获取所有JSON元素，按优先级尝试解析
      const jsonElements = this.querySelectorAll('[type="application/json"]');
      console.log(`🔍 找到 ${jsonElements.length} 个JSON元素`);
      
      for (let i = 0; i < jsonElements.length; i++) {
        const jsonElement = jsonElements[i];
        console.log(`📄 尝试解析第 ${i + 1} 个JSON元素`);
        if (jsonElement.id && jsonElement.id.indexOf('free') > -1) {
          continue;
        }
        try {
          let jsonText = jsonElement.textContent.trim();
          
          if (!jsonText) {
            console.log('⚠️ JSON元素为空，跳过');
            continue;
          }
          
          console.log('📄 原始JSON文本前200字符:', jsonText.substring(0, 200) + '...');
          
          // 递归解析JSON，处理多重序列化
          let parsedData = this.recursiveJsonParse(jsonText);
          
          if (parsedData === null) {
            console.error('❌ JSON解析失败，尝试下一个元素');
            continue;
          }
          
          // 验证数据格式
          if (!Array.isArray(parsedData)) {
            console.log('⚠️ 数据不是数组格式，跳过:', typeof parsedData);
            continue;
          }
          
          // 验证数组中的对象（只处理正常的对象格式）
          const validVariants = [];
          let hasValidVariant = false;
          
          for (const variant of parsedData) {
            // 直接处理对象格式的变体（移除字符串格式处理）
            if (variant && typeof variant === 'object' && variant.id) {
              // 确保变体有options数组
              if (!variant.options) {
                variant.options = [
                  variant.option1,
                  variant.option2,
                  variant.option3
                ].filter(option => option !== null && option !== undefined);
              }
              validVariants.push(variant);
              hasValidVariant = true;
            } else {
              console.warn('⚠️ 跳过无效变体格式:', typeof variant, variant);
            }
          }
          
          if (hasValidVariant && validVariants.length > 0) {
            console.log(`✅ 第 ${i + 1} 个JSON元素解析成功，有效变体数量:`, validVariants.length);
            console.log('📊 变体数据示例:', validVariants[0]);
            
            // 缓存完整的变体数据（包含免费样品）
            this.allVariantData = validVariants;
            
            // 过滤出付费变体用于变体选择器
            const paidVariants = validVariants.filter(variant => {
              const variantPrice = variant.price || 0;
              return variantPrice > 0;
            });
            
            // 缓存过滤后的付费变体数据
            this.variantData = paidVariants;
            
            console.log(`🔍 变体数据缓存: 总变体 ${validVariants.length} 个, 付费变体 ${paidVariants.length} 个`);
            
            // 根据参数返回相应数据
            return includeFreeVariants ? this.allVariantData : this.variantData;
          } else {
            console.log(`⚠️ 第 ${i + 1} 个JSON元素没有有效变体数据`);
          }
          
        } catch (error) {
          console.error(`❌ 第 ${i + 1} 个JSON元素解析失败:`, error);
          continue; // 尝试下一个JSON元素
        }
      }
      
      console.error('❌ 所有JSON元素都解析失败');
      // 不缓存失败的结果，下次调用时重新尝试
      return [];
    }

    // 递归解析JSON，处理多重序列化
    recursiveJsonParse(jsonText, depth = 0) {
      const maxDepth = 5; // 防止无限递归
      
      if (depth > maxDepth) {
        console.error('❌ JSON解析深度超限');
        return null;
      }
      
      try {
        let parsed = JSON.parse(jsonText);
        
        // 如果解析结果是字符串，继续递归解析
        if (typeof parsed === 'string') {
          console.log(`⚠️ 检测到第${depth + 1}层序列化，继续解析`);
          return this.recursiveJsonParse(parsed, depth + 1);
        }
        
        console.log(`✅ JSON解析成功，深度: ${depth}`);
        return parsed;
        
      } catch (error) {
        console.error(`❌ 第${depth}层JSON解析失败:`, error);
        return null;
      }
    }

    updateFreeSwatchesButton() {
      const freeSwatchesButton = document.querySelector(`#free-swatches-button-${this.dataset.section}`);
      const freeVariantsScript = document.querySelector(`#free-variants-data-${this.dataset.section}`);
      
      if (!freeSwatchesButton || !freeVariantsScript) return;
      
      const freeVariants = JSON.parse(freeVariantsScript.textContent);
      const hasFreeVariants = freeVariants && freeVariants.length > 0;
      
      // 总是添加点击事件监听器（如果还没有添加）
      if (!freeSwatchesButton.hasAttribute('data-listener-added')) {
        freeSwatchesButton.addEventListener('click', (e) => {
          e.preventDefault();
          console.log('🔍 免费样品按钮被点击');
          console.log('免费变体数据:', freeVariants);
          this.openFreeSwatchesDrawer(freeVariants);
        });
        freeSwatchesButton.setAttribute('data-listener-added', 'true');
        console.log('✅ 免费样品按钮事件监听器已添加');
      }
      
      // 根据是否有免费变体来更新按钮状态（而不是当前变体是否免费）
      if (hasFreeVariants) {
        freeSwatchesButton.classList.remove('disabled');
        freeSwatchesButton.removeAttribute('disabled');
        console.log('✅ 免费样品按钮已启用，免费变体数量:', freeVariants.length);
      } else {
        freeSwatchesButton.classList.add('disabled');
        freeSwatchesButton.setAttribute('disabled', 'disabled');
        console.log('❌ 免费样品按钮已禁用，没有免费变体');
      }
    }

    openFreeSwatchesDrawer(freeVariants) {
      // 查找现有的样品抽屉
      let swatchesDrawer = document.querySelector('.free-swatch-popup');
      
      if (!swatchesDrawer) {
        console.log('没有找到现有的 swatches drawer');
        return;
      }
      
      // 确保使用完整的免费变体数据
      const completeVariantData = this.getVariantData(true); // 获取包含免费样品的完整数据
      console.log('🎯 免费样品抽屉使用完整变体数据:', completeVariantData.length);
      
      // 更新抽屉中的产品数据
      this.updateSwatchesDrawerContent(swatchesDrawer, freeVariants);
      
      // 显示抽屉
      swatchesDrawer.classList.add('active');
      const fsInner = swatchesDrawer.querySelector('.fs-inner');
      if (fsInner) {
        fsInner.classList.add('active');
      }
      document.body.classList.add('free-swatches-open');
      
      // 设置事件监听器
      this.setupDrawerEventListeners();
    }

    updateSwatchesDrawerContent(swatchesDrawer, freeVariants) {
      const product = this.getProductData();
      
      // 更新产品标题
      const productTitle = swatchesDrawer.querySelector('.product-title');
      if (productTitle) {
        productTitle.textContent = product.title || '产品';
      }
      
      // 更新免费变体列表 - 使用模板和数据绑定而非 innerHTML
      const allFsContainer = swatchesDrawer.querySelector('.all-fs');
      const template = document.getElementById('swatch-item-template');
      
      if (allFsContainer && template && freeVariants.length > 0) {
        // 清除现有的样品项目（保留模板）
        const existingItems = allFsContainer.querySelectorAll('.each-fs:not(template *)');
        existingItems.forEach(item => item.remove());
        
        // 为每个免费变体创建新的元素
        freeVariants.forEach(variant => {
          const clone = template.content.cloneNode(true);
          const eachFs = clone.querySelector('.each-fs');
          const img = clone.querySelector('img');
          const fsTitle = clone.querySelector('.fs-title');
          
          // 设置数据属性
          eachFs.dataset.variantId = variant.id;
          eachFs.dataset.imageUrl = variant.featured_image?.src || '';
          eachFs.dataset.firstTitle = product.title;
          eachFs.dataset.secondTitle = variant.title;
          
          // 设置图片
          if (img && variant.featured_image?.src) {
            img.src = variant.featured_image.src;
            img.alt = variant.title;
          }
          
          // 设置标题
          if (fsTitle) {
            fsTitle.textContent = variant.title;
          }
          
          // 添加到容器
          allFsContainer.appendChild(clone);
        });
        
        // 生成内容后更新按钮状态
        this.updateMainAreaButtonState();
      }
    }

    getProductData() {
      const productScript = document.querySelector('#ProductJSON-product') || 
                           document.querySelector('[type="application/json"][data-product]') ||
                           document.querySelector('script[data-product-json]');
      
      if (productScript) {
        return JSON.parse(productScript.textContent);
      }
      
      // 如果没找到产品JSON，返回基本信息
      return {
        title: document.querySelector('.product-title')?.textContent || 'Product',
        id: this.dataset.productId || ''
      };
    }

    setupDrawerEventListeners() {
      const drawer = document.querySelector('.free-swatch-popup');
      if (!drawer) return;
      
      // 避免重复添加事件监听器
      if (drawer.hasAttribute('data-listeners-setup')) return;
      drawer.setAttribute('data-listeners-setup', 'true');
      
      // 关闭按钮
      const closeBtn = drawer.querySelector('.close');
      closeBtn?.addEventListener('click', () => {
        drawer.classList.remove('active');
        const fsInner = drawer.querySelector('.fs-inner');
        if (fsInner) {
          fsInner.classList.remove('active');
        }
        document.body.classList.remove('free-swatches-open');
      });
      
      // Order Swatches按钮 - 查找实际的按钮
      const orderBtn = drawer.querySelector('.button') || drawer.querySelector('.dark-btn-loading');
      orderBtn?.addEventListener('click', () => {
        window.location.href = '/cart';
      });
      
      // the-info点击切换
      const theInfo = drawer.querySelector('.the-info');
      theInfo?.addEventListener('click', () => {
        const bottomCon = drawer.querySelector('.bottom-con');
        const middleCon = drawer.querySelector('.middle-con');
        
        if (bottomCon && middleCon) {
          bottomCon.classList.toggle('open');
          if (bottomCon.classList.contains('open')) {
            bottomCon.style.top = 'calc(100% - 359px)';
            middleCon.style.height = 'calc(100% - 414px)';
          } else {
            bottomCon.style.removeProperty('top');
            middleCon.style.removeProperty('height');
          }
        }
      });
      
      // 使用事件委托处理动态添加的按钮
      drawer.addEventListener('click', (e) => {
        // 处理产品区域的加号按钮
        if (e.target.closest('.fs-button.plus')) {
          const button = e.target.closest('.fs-button.plus');
          const eachFs = e.target.closest('.each-fs');
          if (eachFs && !button.classList.contains('loading')) {
            const variantId = eachFs.dataset.variantId;
            this.addSwatchToCart(variantId, button);
          }
        }
        
        // 处理产品区域的减号按钮
        if (e.target.closest('.fs-button.minus') && e.target.closest('.all-fs')) {
          const button = e.target.closest('.fs-button.minus');
          const eachFs = e.target.closest('.each-fs');
          if (eachFs && !button.classList.contains('loading')) {
            const variantId = eachFs.dataset.variantId;
            console.log('🔴 产品区域减号按钮被点击，变体ID:', variantId);
            this.removeSwatchFromCart(variantId, button);
          }
        }
        
        // 处理Selected Swatches区域的删除按钮
        if (e.target.closest('.fs-button') && e.target.closest('.selected-fs')) {
          const button = e.target.closest('.fs-button');
          const eachItem = e.target.closest('.each');
          if (eachItem && !button.classList.contains('loading')) {
            const variantId = eachItem.dataset.variantId;
            console.log('🔴 Selected Swatches删除按钮被点击，变体ID:', variantId);
            this.removeSwatchFromCart(variantId, button);
          }
        }
      });
    }

    async addSwatchToCart(variantId, button) {
      // 检查是否已经添加了这个变体
      const existingIndex = this.selectedSwatches.findIndex(item => item.variantId === variantId);
      if (existingIndex !== -1) {
        console.log('样品已经添加过了');
        return;
      }

      // 检查是否超过限制
      if (this.selectedSwatches.length >= this.maxSwatches) {
        this.showSwatchLimitError();
        return;
      }

      // 添加加载状态
      if (button) {
        button.classList.add('loading');
      }

      try {
        // 调用真实的购物车添加方法
        await this.addToCart(variantId, 1);
        console.log('样品已成功添加到购物车:', variantId);
      } catch (error) {
        console.error('添加样品到购物车失败:', error);
      } finally {
        // 移除加载状态
        if (button) {
          button.classList.remove('loading');
        }
      }
    }

    async removeSwatchFromCart(variantId, button) {
      // 添加加载状态
      if (button) {
        button.classList.add('loading');
      }

      try {
        // 调用真实的移除方法
        await this.removeFromSelectedSwatches(variantId);
        console.log('样品已成功从购物车移除:', variantId);
      } catch (error) {
        console.error('从购物车移除样品失败:', error);
      } finally {
        // 移除加载状态
        if (button) {
          button.classList.remove('loading');
        }
      }
    }

    addToSelectedSwatches(cartItemData, variantId) {
      // 检查是否已经添加了这个变体
      const existingIndex = this.selectedSwatches.findIndex(item => item.variantId === variantId);
      if (existingIndex !== -1) {
        console.log('样品已经添加过了');
        return;
      }

      // 检查是否超过限制
      if (this.selectedSwatches.length >= this.maxSwatches) {
        this.showSwatchLimitError();
        return;
      }

      // 获取变体信息
      const eachFs = document.querySelector(`.each-fs[data-variant-id="${variantId}"]`);
      if (!eachFs) return;

      const swatchData = {
        variantId: variantId,
        title: eachFs.dataset.secondTitle || cartItemData.variant_title || 'Unknown',
        parentTitle: eachFs.dataset.firstTitle || cartItemData.product_title || 'Product',
        imageUrl: eachFs.dataset.imageUrl || cartItemData.image || '',
        cartItemData: cartItemData,
        quantity: cartItemData.quantity
      };

      // 添加到已选数组
      this.selectedSwatches.push(swatchData);

      // 更新UI显示
      this.updateSelectedSwatchesDisplay();
      this.updateSelectedCount();
      this.updateMainAreaButtonState();

      console.log('样品已添加到已选区域:', swatchData);
    }

    async removeFromSelectedSwatches(variantId) {
      const index = this.selectedSwatches.findIndex(item => item.variantId === variantId);
      if (index !== -1) {
        const swatch = this.selectedSwatches[index];
        
        // 从购物车中真实删除
        try {
          await this.removeFromCart(variantId);
          
          // 从本地数组中移除
          this.selectedSwatches.splice(index, 1);
          this.updateSelectedSwatchesDisplay();
          this.updateSelectedCount();
          this.updateMainAreaButtonState();
          this.hideSwatchLimitError();
          
          console.log('样品已从购物车和已选区域删除:', swatch);
        } catch (error) {
          console.error('从购物车删除样品失败:', error);
          // 即使删除失败，也可以考虑从本地移除（根据业务需求决定）
        }
      }
    }

    updateSelectedSwatchesDisplay() {

      const selectedContainer = document.querySelector('.selected-fs');
      const template = document.getElementById('selected-swatch-template');
      
      if (!selectedContainer || !template) return;

      // 清除现有的已选样品项目（保留模板）
      const existingItems = selectedContainer.querySelectorAll('.each:not(template *)');
      existingItems.forEach(item => item.remove());

      // 为每个已选样品创建新的元素
      this.selectedSwatches.forEach(swatch => {
        const clone = template.content.cloneNode(true);
        const eachElement = clone.querySelector('.each');
        const img = clone.querySelector('img');
        const button = clone.querySelector('.fs-button');
        const parentTitle = clone.querySelector('.parent-title');
        const title = clone.querySelector('.title');
        const quantityNode = clone.querySelector('.imgbox__quantity');

        if (quantityNode) {
          quantityNode.textContent = swatch.quantity;
        }
        
        // 设置数据属性
        eachElement.dataset.variantId = swatch.variantId;
        button.dataset.variantId = swatch.variantId;
        
        // 设置图片
        if (img) {
          img.src = swatch.imageUrl;
          img.alt = swatch.title;
        }
        
        // 设置文本内容
        if (parentTitle) {
          parentTitle.textContent = swatch.parentTitle;
        }
        if (title) {
          title.textContent = swatch.title;
        }
        
        // 添加到容器
        selectedContainer.appendChild(clone);
      });

      // 添加移除事件监听器（只添加一次，使用事件委托）
      if (!selectedContainer.hasAttribute('data-listener-added')) {
        selectedContainer.addEventListener('click', (e) => {
          if (e.target.closest('.fs-button')) {
            const button = e.target.closest('.fs-button');
            const variantId = button.dataset.variantId;
            
            // 防止重复点击
            if (button.classList.contains('loading')) return;
            
            // 添加加载状态
            button.classList.add('loading');
            
            this.removeFromSelectedSwatches(variantId).finally(() => {
              // 移除加载状态（如果按钮还存在的话）
              if (button.parentNode) {
                button.classList.remove('loading');
              }
            });
          }
        });
        selectedContainer.setAttribute('data-listener-added', 'true');
      }
    }

    updateSelectedCount() {
      const countElement = document.querySelector('.the-info .text span');
      if (countElement) {
        countElement.textContent = `(${this.selectedSwatches.reduce((acc, swatch) => acc + swatch.quantity, 0)})`;
      }
    }

    showSwatchLimitError() {
      const errorElement = document.querySelector('.exceed-error');
      if (errorElement) {
        const numberSpan = errorElement.querySelector('.number');
        if (numberSpan) {
          numberSpan.textContent = '1';
        }
        errorElement.classList.remove('hidden-360');
      }
    }

    hideSwatchLimitError() {
      const errorElement = document.querySelector('.exceed-error');
      if (errorElement && this.selectedSwatches.length < this.maxSwatches) {
        errorElement.classList.add('hidden-360');
      }
    }

    updateMainAreaButtonState() {
      // 获取所有主要区域的免费样品项目
      const allFsItems = document.querySelectorAll('.all-fs .each-fs');
      
      allFsItems.forEach(item => {
        const variantId = item.dataset.variantId;
        const isSelected = this.selectedSwatches.some(swatch => swatch.variantId === variantId);
        
        // 获取加号和减号按钮
        const plusButton = item.querySelector('.fs-button.plus');
        const minusButton = item.querySelector('.fs-button.minus');
        
        if (isSelected) {
          // 已选中状态：添加 selected 类，显示减号按钮，隐藏加号按钮
          item.classList.add('selected');
          if (plusButton) plusButton.style.display = 'none';
          if (minusButton) minusButton.style.display = 'flex';
        } else {
          // 未选中状态：移除 selected 类，显示加号按钮，隐藏减号按钮
          item.classList.remove('selected');
          if (plusButton) plusButton.style.display = 'flex';
          if (minusButton) minusButton.style.display = 'none';
        }
      });
      
      console.log('🔄 主要区域按钮状态已更新，选中数量:', this.selectedSwatches.length);
    }

    async addToCart(variantId, quantity = 1) {
      try {
        // 创建FormData来匹配普通加购的请求格式
        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', quantity);
        formData.append('sections', this.getSectionsToRender().map((section) => section.section));
        formData.append('sections_url', window.location.pathname);

        const response = await fetch('/cart/add', {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/javascript'
          },
          body: formData
        });
        
        if (response.ok) {
          const data = await response.json();
          const addedProduct = data.hasOwnProperty('items') ? data.items[0] : data;
          
          // 检查是否为免费样品（价格为0）
          if (addedProduct.title.indexOf('Free')) {
            // 添加到已选样品区域
            this.addToSelectedSwatches(addedProduct, variantId);
            
            // 使用与普通商品相同的购物车同步机制
            this.renderContents(data);
          }
          
          // 触发自定义事件通知添加成功
          dispatchCustomEvent('cart:item-added', {
            product: addedProduct
          });
        } else {
          const errorData = await response.json();
          console.error('添加到购物车失败:', errorData);
        }
      } catch (error) {
        console.error('添加到购物车失败:', error);
      }
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }

    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (section.id === 'Cart-Drawer') {
          document.getElementById('Cart-Drawer')?.notesToggle();
          document.getElementById('Cart-Drawer')?.removeProductEvent();
        }
        if (section.id === 'Cart' && typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

    async removeFromCart(variantId) {
      try {
        // 首先获取购物车信息来找到具体的line item
        const cartResponse = await fetch('/cart.js', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        });
        
        if (cartResponse.ok) {
          const cartData = await cartResponse.json();
          const item = cartData.items.find(item => item.variant_id.toString() === variantId.toString());
          
          if (item) {
            // 创建FormData来匹配购物车更新的请求格式
            const formData = new FormData();
            formData.append('id', variantId);
            formData.append('quantity', '0');
            formData.append('sections', this.getSectionsToRender().map((section) => section.section));
            formData.append('sections_url', window.location.pathname);

            const response = await fetch('/cart/change', {
              method: 'POST',
              headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Accept': 'application/javascript'
              },
              body: formData
            });
            
            if (response.ok) {
              const data = await response.json();
              
              // 使用与加购相同的购物车同步机制
              this.renderContents(data);
              
              // 触发自定义事件通知删除成功
              dispatchCustomEvent('cart:item-removed', {
                variantId: variantId,
                cartData: data
              });
              
              return data;
            } else {
              const errorData = await response.json();
              throw new Error(errorData.message || '删除失败');
            }
          } else {
            console.warn('在购物车中未找到该变体:', variantId);
          }
        } else {
          throw new Error('获取购物车信息失败');
        }
      } catch (error) {
        console.error('从购物车删除商品失败:', error);
        throw error;
      }
    }

    async loadSelectedSwatchesFromCart() {
      try {
        // 获取购物车数据
        const cartResponse = await fetch('/cart.js', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        });

        if (cartResponse.ok) {
          const cartData = await cartResponse.json();
          
          // 筛选出价格为0的免费样品
          const freeSwatchItems = cartData.items.filter(item => item.title.indexOf('Free'));
          
          if (freeSwatchItems.length > 0) {
            // 重建 selectedSwatches 数组
            this.selectedSwatches = freeSwatchItems.map(item => ({
              variantId: item.variant_id.toString(),
              title: item.variant_title || item.title || 'Unknown',
              parentTitle: item.product_title || 'Product',
              imageUrl: item.image || '',
              cartItemData: item,
              quantity: item.quantity
            }));

            // 更新UI显示
            this.updateSelectedSwatchesDisplay();
            this.updateSelectedCount();
            this.updateMainAreaButtonState();
            
            console.log('已从购物车恢复免费样品数据:', this.selectedSwatches.length, '个样品');
          }
        } else {
          console.warn('获取购物车数据失败:', cartResponse.status);
        }
      } catch (error) {
        console.error('从购物车加载免费样品数据时出错:', error);
      }
    }
  }
  customElements.define('variant-selects', VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  }

  customElements.define('variant-radios', VariantRadios);
}

if (!customElements.get('product-slider')) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      this.pagination = this.parentElement.querySelector('.product-images-buttons');
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.video_containers = this.querySelectorAll('.product-single__media-external-video--play');

      // Start Gallery
      let observer = new MutationObserver(() => {
        this.setupProductGallery();
      });

      observer.observe(this, {
        attributes: true,
        attributeFilter: ['class'],
        childList: true,
        characterData: false
      });

      this.setupProductGallery();

      // Start Pagination
      if (this.pagination) {
        this.setupPagination();
        this.resizeObserver = new ResizeObserver(entries => this.onPaginationResize());
        this.resizeObserver.observe(this);
        this.addEventListener('scroll', this.updatePagination.bind(this));
      }
    }
    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }

      this.setEventListeners();
    }
    buildItems(activeImages) {
      let images = activeImages.map((item) => {
        let activelink = item.querySelector('.product-single__media-zoom');
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h,
          title: activelink.getAttribute('title')
        };
      });
      return images;
    }
    setEventListeners() {
      let activeImages = Array.from(this.querySelectorAll('.product-images__slide--image')).filter(element => element.clientWidth > 0),
        items = this.buildItems(activeImages),
        captionEl = this.dataset.captions,
        pswpElement = document.querySelectorAll('.pswp')[0],
        options = {
          maxSpreadZoom: 2,
          loop: false,
          allowPanToNext: false,
          closeOnScroll: false,
          showHideOpacity: false,
          arrowKeys: true,
          history: false,
          captionEl: captionEl,
          fullscreenEl: false,
          zoomEl: false,
          shareEl: false,
          counterEl: true,
          arrowEl: true,
          preloaderEl: true
        };

      let openPswp = function (e, link, options, pswpElement, items) {
        let parent = link.closest('.product-images__slide');
        let i = activeImages.indexOf(parent);
        options.index = parseInt(i, 10);
        options.getThumbBoundsFn = () => {
          const thumbnail = link.closest('.product-single__media'),
            pageYScroll = window.scrollY || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        };
        if (typeof PhotoSwipe !== 'undefined') {
          let pswp = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);

          pswp.listen('firstUpdate', () => {
            pswp.listen('parseVerticalMargin', function (item) {
              item.vGap = {
                top: 50,
                bottom: 50
              };
            });
          });
          pswp.init();
        }
        e.preventDefault();
      };
      this.querySelectorAll('.product-single__media-zoom').forEach(function (link) {
        let thumbnail = link.closest('.product-single__media');
        let clone = link.cloneNode(true);
        thumbnail.append(clone);
        link.remove();
        clone.addEventListener('click', (e) => openPswp(e, clone, options, pswpElement, items));
      });

      this.video_containers.forEach((container) => {
        container.querySelector('button').addEventListener('click', function () {
          container.setAttribute('hidden', '');
        });
      });
    }
    setupPagination() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) return;

      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;

      this.currentPageElement = this.pagination.querySelector('.slider-counter--current');
      this.pageTotalElement = this.pagination.querySelector('.slider-counter--total');

      this.prevButton = this.pagination.querySelector('button[name="previous"]');
      this.nextButton = this.pagination.querySelector('button[name="next"]');


      this.prevButton.addEventListener('click', this.onPaginationButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onPaginationButtonClick.bind(this));

      this.updatePagination();
    }
    onPaginationResize() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);

      if (this.sliderItemsToShow.length < 2) return;

      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
      this.updatePagination();
    }
    onPaginationButtonClick(event) {
      event.preventDefault();
      this.slideScrollPosition = event.currentTarget.name === 'next' ? this.scrollLeft + (1 * this.sliderItemOffset) : this.scrollLeft - (1 * this.sliderItemOffset);
      this.scrollTo({
        left: this.slideScrollPosition
      });
    }
    updatePagination() {
      if (!this.nextButton) return;

      const previousPage = this.currentPage;
      this.currentPage = Math.round(this.scrollLeft / this.sliderItemOffset) + 1;

      if (this.currentPageElement) {
        this.currentPageElement.textContent = this.currentPage;
      }
      if (this.pageTotalElement) {
        this.pageTotalElement.textContent = this.sliderItemsToShow.length;
      }

      if (this.currentPage != previousPage) {
        this.dispatchEvent(new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1]
          }
        }));
      }

      if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.scrollLeft === 0) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }

      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }
    isSlideVisible(element, offset = 0) {
      const lastVisibleSlide = this.clientWidth + this.scrollLeft - offset;
      return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.scrollLeft;
    }
  }
  customElements.define('product-slider', ProductSlider);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.sticky = this.dataset.sticky;
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      this.form.querySelector('[name=id]').disabled = false;
      if (!this.sticky) {
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      this.cartNotification = document.querySelector('cart-notification');
      this.body = document.body;

      this.hideErrors = this.dataset.hideErrors === 'true';
    }
    onSubmitHandler(evt) {
      evt.preventDefault();
      if (!this.form.reportValidity()) {
        return;
      }
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      submitButtons.forEach((submitButton) => {
        if (submitButton.classList.contains('loading')) return;
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
      });

      this.handleErrorMessage();


      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };
      let formData = new FormData(this.form);

      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            dispatchCustomEvent('product:variant-error', {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message
            });
            if (response.status === 422) {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
              }));
            }
            this.handleErrorMessage(response.description);
            return;
          }

          const addedProduct = response.hasOwnProperty('items') ? response.items[0] : response;
          
          // 检查产品价格，如果为0则添加到免费样品面板
          if (addedProduct.title.indexOf('Free')) {
            // 如果存在免费样品面板的Vue应用，添加到免费样品面板
            if (window.vueApp && window.vueApp.addToFreeSwatchesPanel) {
              window.vueApp.addToFreeSwatchesPanel(
                addedProduct, 
                addedProduct.variant_id, 
                addedProduct.handle || '', 
                addedProduct.product_title || '', 
                addedProduct.variant_title || '', 
                addedProduct.image || ''
              );
              // 不执行 renderContents，避免显示购物车抽屉
            } else {
              // 如果Vue应用不存在，仍然执行正常流程
              this.renderContents(response);
            }
          } else {
            // 价格大于0，执行正常购物车流程
            this.renderContents(response);
          }

          dispatchCustomEvent('cart:item-added', {
            product: addedProduct
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButtons.forEach((submitButton) => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          });
        });
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (section.id === 'Cart-Drawer') {
          document.getElementById('Cart-Drawer')?.notesToggle();
          document.getElementById('Cart-Drawer')?.removeProductEvent();
        }
        if (section.id === 'Cart' && typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));



      let product_drawer = document.getElementById('Product-Drawer');
      if (product_drawer && product_drawer.contains(this)) {
        product_drawer.querySelector('.product-quick-images--container').classList.remove('active');
        document.body.classList.remove('open-quick-view');

        if (window.innerWidth < 1069) {
          product_drawer.classList.remove('active');
          if (document.getElementById('Cart-Drawer')) {
            document.getElementById('Cart-Drawer').classList.add('active');
            document.body.classList.add('open-cart');
            document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
            dispatchCustomEvent('cart-drawer:open');
          }
        } else {
          product_drawer.querySelector('.product-quick-images--container').addEventListener('transitionend', function () {
            product_drawer.classList.remove('active');

            if (document.getElementById('Cart-Drawer')) {
              document.getElementById('Cart-Drawer').classList.add('active');
              document.body.classList.add('open-cart');
              document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
              dispatchCustomEvent('cart-drawer:open');
            }
          });
        }

        if (!document.getElementById('Cart-Drawer')) {
          document.body.classList.remove('open-cc');
        }
      } else if (document.getElementById('Cart-Drawer')) {
        document.body.classList.add('open-cc');
        document.body.classList.add('open-cart');
        document.getElementById('Cart-Drawer').classList.add('active');
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

/**
 *  @class
 *  @function ProductAddToCartSticky
 */
if (!customElements.get('product-add-to-cart-sticky')) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();

      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
    }
    connectedCallback() {
      this.setupObservers();
      this.setupToggle();
    }
    setupToggle() {
      const button = this.querySelector('.product-add-to-cart-sticky--inner'),
        content = this.querySelector('.product-add-to-cart-sticky--content');

      if (this.animations_enabled) {
        const tl = gsap.timeline({
          reversed: true,
          paused: true,
          onStart: () => {
            button.classList.add('sticky-open');
          },
          onReverseComplete: () => {
            button.classList.remove('sticky-open');
          }
        });

        tl
          .set(content, {
            display: 'block',
            height: 'auto'
          }, 'start')
          .from(content, {
            height: 0,
            duration: 0.25
          }, 'start+=0.001');

        button.addEventListener('click', function () {
          tl.reversed() ? tl.play() : tl.reverse();

          return false;
        });
      } else {
        button.addEventListener('click', function () {
          content.classList.toggle('active');
          return false;
        });
      }


    }
    setupObservers() {
      let _this = this,
        observer = new IntersectionObserver(function (entries) {
          entries.forEach((entry) => {
            if (entry.target === footer) {
              if (entry.intersectionRatio > 0) {
                _this.classList.remove('sticky--visible');
              } else if (entry.intersectionRatio == 0 && _this.formPassed) {
                _this.classList.add('sticky--visible');
              }
            }
            if (entry.target === form) {
              let boundingRect = form.getBoundingClientRect();

              if (entry.intersectionRatio === 0 && window.scrollY > (boundingRect.top + boundingRect.height)) {
                _this.formPassed = true;
                _this.classList.add('sticky--visible');
              } else if (entry.intersectionRatio === 1) {
                _this.formPassed = false;
                _this.classList.remove('sticky--visible');
              }
            }
          });
        }, {
          threshold: [0, 1]
        }),
        form = document.getElementById(`product-form-${this.dataset.section}`),
        footer = document.getElementById('footer');
      _this.formPassed = false;
      observer.observe(form);
      observer.observe(footer);
    }
  }

  customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}

if (typeof addIdToRecentlyViewed !== "undefined") {
  addIdToRecentlyViewed();
}